//src\components\AttachmentComponent.css.js
import { StyleSheet } from 'react-native';
import { AVAQualisTheme } from '../theme/theme';

export const styles = StyleSheet.create({
  container: {
    marginTop: AVAQualisTheme.spacing.md,
  },
  
  // Botões de Ação
  actionButtons: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: AVAQualisTheme.spacing.xs,
    marginBottom: AVAQualisTheme.spacing.sm,
    flexWrap: 'wrap',
  },
  actionButton: {
    flex: 1,
    minWidth: 100,
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderColor: AVAQualisTheme.colors.primary,
    position: 'relative',
  },
  disabledButton: {
    opacity: 0.5,
    borderColor: AVAQualisTheme.colors.outline,
  },
  buttonContent: {
    height: 56,
    paddingHorizontal: AVAQualisTheme.spacing.md,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonLabel: {
    fontSize: 14,
    fontWeight: '700',
    textAlign: 'center',
  },
  buttonBadge: {
    position: 'absolute',
    top: -8,
    right: -8,
    backgroundColor: AVAQualisTheme.colors.primary,
    minWidth: 18,
    height: 18,
  },
  
  // Lista de Anexos
  attachmentsList: {
    marginTop: AVAQualisTheme.spacing.sm,
  },
  attachmentsTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: AVAQualisTheme.colors.primary,
    marginBottom: AVAQualisTheme.spacing.sm,
  },
  
  // ✅ CARD DO ANEXO ATUALIZADO - Com hover e interatividade
  attachmentCard: {
    marginBottom: AVAQualisTheme.spacing.sm,
    backgroundColor: AVAQualisTheme.colors.surfaceVariant,
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderLeftWidth: 3,
    borderLeftColor: AVAQualisTheme.colors.info,
    elevation: 1,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  
  // ✅ NOVO - Estado hover do card
  attachmentCardHovered: {
    elevation: 4,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 8,
    borderLeftColor: AVAQualisTheme.colors.primary,
    borderLeftWidth: 4,
    backgroundColor: AVAQualisTheme.colors.surface,
    transform: [{ scale: 1.02 }],
  },
  
  attachmentContent: {
    paddingVertical: AVAQualisTheme.spacing.sm,
    paddingHorizontal: AVAQualisTheme.spacing.sm,
  },
  attachmentHeader: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  attachmentInfo: {
    flexDirection: 'row',
    flex: 1,
    alignItems: 'flex-start',
  },
  
  // ✅ ÍCONE/THUMBNAIL ATUALIZADO - Com overlay
  attachmentIcon: {
    width: 60,
    height: 60,
    borderRadius: AVAQualisTheme.borderRadius.md,
    marginRight: AVAQualisTheme.spacing.sm,
    backgroundColor: AVAQualisTheme.colors.surface,
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    position: 'relative',
  },
  
  // ✅ NOVO - Overlay de hover no ícone - CORRIGIDO
  hoverOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.25)', // ✅ CORREÇÃO: Fundo mais claro
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: AVAQualisTheme.borderRadius.md,
  },
  
  hoverIcon: {
    fontSize: 20,
    color: 'white',
  },
  
  hoverText: {
    fontSize: 10,
    color: 'white',
    fontWeight: 'bold',
    marginTop: 2,
  },
  
  thumbnailImage: {
    width: '100%',
    height: '100%',
    borderRadius: AVAQualisTheme.borderRadius.md,
  },
  videoThumbnail: {
    width: '100%',
    height: '100%',
    backgroundColor: AVAQualisTheme.colors.surface,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderWidth: 2,
    borderColor: AVAQualisTheme.colors.primary,
  },
  videoIcon: {
    fontSize: 24,
  },
  linkIcon: {
    width: '100%',
    height: '100%',
    backgroundColor: AVAQualisTheme.colors.info + '20',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderWidth: 2,
    borderColor: AVAQualisTheme.colors.info,
  },
  linkIconText: {
    fontSize: 20,
  },
  fileIcon: {
    fontSize: 28,
  },
  
  // Detalhes do Anexo
  attachmentDetails: {
    flex: 1,
    paddingRight: AVAQualisTheme.spacing.xs,
  },
  attachmentName: {
    fontSize: 14,
    fontWeight: '600',
    color: AVAQualisTheme.colors.onSurface,
    marginBottom: 2,
  },
  attachmentSize: {
    fontSize: 11,
    color: AVAQualisTheme.colors.secondary,
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  attachmentDescription: {
    fontSize: 12,
    color: AVAQualisTheme.colors.secondary,
    fontStyle: 'italic',
    lineHeight: 16,
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  
  // NOVO - Estilo para data de validade
  attachmentValidity: {
    fontSize: 11,
    color: AVAQualisTheme.colors.tertiary,
    fontWeight: '600',
    marginTop: 2,
  },
  attachmentValidityExpired: {
    color: AVAQualisTheme.colors.error,
  },
  attachmentValidityWarning: {
    color: AVAQualisTheme.colors.warning,
  },
  
  // ✅ AÇÕES DO ANEXO ATUALIZADAS - Com botão principal destacado
  attachmentActions: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: 6,
  },
  
  // ✅ NOVO - Botão principal de visualização (lupa) - CORRIGIDO
  viewButtonMain: {
    margin: 0,
    backgroundColor: `${AVAQualisTheme.colors.primary}15`,
    borderWidth: 2,
    borderColor: AVAQualisTheme.colors.primary,
    borderRadius: 50,
  },
  
  viewButtonMainHovered: {
    backgroundColor: AVAQualisTheme.colors.primary,
    transform: [{ scale: 1.1 }],
  },
  
  // ✅ NOVO - Botões secundários (menores)
  secondaryActionButton: {
    margin: 0,
    backgroundColor: 'transparent',
  },
  
  // ✅ NOVO - Tooltip de preview
  previewTooltip: {
    marginTop: AVAQualisTheme.spacing.sm,
    padding: AVAQualisTheme.spacing.xs,
    backgroundColor: `${AVAQualisTheme.colors.primary}10`,
    borderRadius: AVAQualisTheme.borderRadius.sm,
    borderLeftWidth: 2,
    borderLeftColor: AVAQualisTheme.colors.primary,
  },
  
  tooltipText: {
    fontSize: 11,
    color: AVAQualisTheme.colors.primary,
    fontWeight: '600',
    textAlign: 'center',
  },
  
  tooltipSubtext: {
    fontSize: 10,
    color: AVAQualisTheme.colors.secondary,
    textAlign: 'center',
    marginTop: 2,
  },
  
  // NOVO - Seção de validade no card
  validitySection: {
    marginTop: AVAQualisTheme.spacing.xs,
    paddingTop: AVAQualisTheme.spacing.xs,
    borderTopWidth: 1,
    borderTopColor: AVAQualisTheme.colors.outline + '30',
    flexDirection: 'column', // ✅ MELHORADO: Mudado para column para melhor organização
    justifyContent: 'flex-start',
    alignItems: 'stretch',
  },
  validityInfo: {
    flex: 1,
  },
  validityLabel: {
    fontSize: 11,
    color: AVAQualisTheme.colors.secondary,
    fontWeight: '500',
  },
  validityDate: {
    fontSize: 12,
    fontWeight: '600',
  },
  validityActions: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  
  // Dialogs - ESTRUTURA SIMPLES
  modalButtonDisabled: {
    backgroundColor: '#CCCCCC',
    opacity: 0.7,
  },
  
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  modalContent: {
    backgroundColor: 'white',
    borderRadius: 12,
    padding: 20,
    minWidth: 300,
    maxWidth: '90%',
    maxHeight: '80%',
    elevation: 10,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 8,
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
    textAlign: 'center',
    marginBottom: 20,
  },
  modalInput: {
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.outline,
    borderRadius: 8,
    padding: 12,
    fontSize: 16,
    backgroundColor: 'white',
    marginBottom: 15,
  },
  modalInputMultiline: {
    height: 100,
    textAlignVertical: 'top',
  },
  modalLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: AVAQualisTheme.colors.secondary,
    marginBottom: 5,
  },
  modalCharCount: {
    fontSize: 12,
    color: AVAQualisTheme.colors.secondary,
    textAlign: 'right',
    marginBottom: 15,
  },
  
  // NOVO - Estilos para seleção de data de validade
  validityToggle: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  validityCheckbox: {
    width: 20,
    height: 20,
    borderWidth: 2,
    borderColor: AVAQualisTheme.colors.primary,
    borderRadius: 3,
    marginRight: 8,
    justifyContent: 'center',
    alignItems: 'center',
  },
  validityCheckboxChecked: {
    backgroundColor: AVAQualisTheme.colors.primary,
  },
  validityCheckmark: {
    color: 'white',
    fontSize: 12,
    fontWeight: 'bold',
  },
  validityToggleText: {
    fontSize: 14,
    color: AVAQualisTheme.colors.onSurface,
  },
  
  // NOVO - Container da data
  dateInputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    marginBottom: 5, // ✅ MELHORADO: Adicionado espaçamento inferior
  },
  dateInput: {
    flex: 1,
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.outline,
    borderRadius: 8,
    padding: 12,
    fontSize: 16,
    backgroundColor: 'white',
  },
  calendarButton: {
    backgroundColor: AVAQualisTheme.colors.primary,
    borderRadius: 8,
    padding: 12,
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 50,
  },
  calendarButtonText: {
    color: 'white',
    fontSize: 20,
  },
  
  modalButtons: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 10,
    marginTop: 10,
  },
  modalButtonCancel: {
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.outline,
    borderRadius: 8,
    paddingHorizontal: 20,
    paddingVertical: 12,
  },
  modalButtonSave: {
    backgroundColor: AVAQualisTheme.colors.primary,
    borderRadius: 8,
    paddingHorizontal: 20,
    paddingVertical: 12,
  },
  modalButtonText: {
    fontSize: 14,
    fontWeight: '600',
    textAlign: 'center',
  },
  modalButtonTextCancel: {
    color: AVAQualisTheme.colors.secondary,
  },
  modalButtonTextSave: {
    color: 'white',
  },
  
  // NOVO - Estilos para dialog de confirmação de exclusão
  confirmationDialog: {
    alignItems: 'center',
  },
  confirmationIcon: {
    fontSize: 48,
    marginBottom: 16,
  },
  confirmationMessage: {
    fontSize: 16,
    textAlign: 'center',
    color: AVAQualisTheme.colors.onSurface,
    lineHeight: 24,
    marginBottom: 20,
  },
  confirmationButtons: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 15,
    width: '100%',
  },
  confirmationButtonCancel: {
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.outline,
    borderRadius: 8,
    paddingHorizontal: 24,
    paddingVertical: 12,
    flex: 1,
  },
  confirmationButtonDelete: {
    backgroundColor: AVAQualisTheme.colors.error,
    borderRadius: 8,
    paddingHorizontal: 24,
    paddingVertical: 12,
    flex: 1,
  },
  
  // ADICIONANDO ESTILOS PARA MONGODB E SINCRONIZAÇÃO
  
  // Indicador de sincronização
  syncIndicator: {
    backgroundColor: '#FFF3CD',
    padding: 8,
    borderRadius: 4,
    marginBottom: 10,
    borderWidth: 1,
    borderColor: '#FFE69C',
  },
  syncIndicatorPending: {
    backgroundColor: '#D1ECF1',
    padding: 8,
    borderRadius: 4,
    marginBottom: 10,
    borderWidth: 1,
    borderColor: '#BEE5EB',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  syncIndicatorText: {
    color: '#856404',
    fontSize: 12,
    textAlign: 'center',
  },
  
  // Badge MongoDB
  mongoBadge: {
    position: 'absolute',
    bottom: -2,
    right: -2,
    backgroundColor: '#4CAF50',
    borderRadius: 10,
    width: 20,
    height: 20,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2,
  },
  mongoBadgeText: {
    fontSize: 10,
    color: 'white',
  },
  
  // Status de sincronização
  syncStatus: {
    fontSize: 10,
    marginTop: 4,
  },
  syncStatusComplete: {
    color: '#4CAF50',
  },
  syncStatusPending: {
    color: '#FFC107',
  },
  
  // Botão de sincronização
  syncButton: {
    backgroundColor: '#007BFF',
    padding: 8,
    borderRadius: 4,
    marginTop: 5,
    marginBottom: 10,
    alignItems: 'center',
  },
  syncButtonText: {
    color: 'white',
    fontWeight: 'bold',
  },
  
  // Status MongoDB no modal
  mongoStatusSection: {
    marginTop: 10,
    marginBottom: 5,
    padding: 8,
    backgroundColor: '#F8F9FA',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#E9ECEF',
  },
  mongoStatusText: {
    fontSize: 12,
    color: '#6C757D',
    textAlign: 'center',
  },
  
  // Modal pequeno
  smallModalContent: {
    maxWidth: 320,
    width: '90%',
  },
  
  // Badges de arquivo
  supabaseBadge: {
    position: 'absolute',
    top: -2,
    right: -2,
    backgroundColor: '#3FCF8E',
    borderRadius: 10,
    width: 20,
    height: 20,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2,
  },
  supabaseBadgeText: {
    fontSize: 10,
    color: 'white',
  },
  
  localOnlyBadge: {
    position: 'absolute',
    top: -2,
    left: -2,
    backgroundColor: '#FFC107',
    borderRadius: 10,
    width: 20,
    height: 20,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2,
  },
  localOnlyBadgeText: {
    fontSize: 10,
    color: 'white',
  }
});